exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hello[data-v-3a208ae2] {\n  /*background-image: url(../assets/images/votre-espace-2-orange.png);*/\n  /*background-position: 0 50px;*/\n  /*background-repeat: no-repeat;*/\n  /*width: 733px;*/\n  /*min-height: 505px;*/\n  /*min-height: calc(100vh - 500px);*/\n  /*margin: auto;*/\n  /*background-image: url(/assets/images/votre-espace-back-ground-orange.jpg);\n  background-size: cover;*/\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a208ae2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotFoundComponent.vue
// module id = 158
// module chunks = 1